import { Paragraph, Select, tokens } from '@welbe/web-design-system';
import { Button } from '@welbe/design-system';
import React, { Fragment, useContext } from 'react';
import {
	Banner,
	BenefitItem,
	Benefits,
	Container,
	Title,
	InfoContainer,
	MoreInfo,
} from './Result.styles';
import calendar from './assets/1.png';
import alert from './assets/2.png';
import computer from './assets/3.png';
import slide from './assets/4.png';
import help from './assets/5.png';
import { JobProfileContext } from 'Views/JobProfile/JobProfile.context';
import { useResult } from './Result.hooks';

export const benefitItems = [
	{
		image: alert,
		text: 'Crea comunicaciones para toda la empresa',
	},
	{
		image: computer,
		text: 'Monitorea el procreso de tus campañas',
	},
	{
		image: slide,
		text: 'Analiza los resultados',
	},
	{
		image: help,
		text: 'Brinda apoyo a quienes lo necesitan',
	},
];

export const examResultOptions = [
	{
		id: 'outStandards',
		value: 'Fuera de norma',
		color: '#F08B2D',
	},
	{
		id: 'inStandards',
		value: 'Dentro de norma',
		color: '#8DC63F',
	},
];

export const Result = () => {
	const { jobRiskFactors, focusedId, setJobRiskFactors } =
		useContext(JobProfileContext);

	const { isCompanyPermited } = useResult();

	const handleSelectResult = (selected: {
		id: 'outStandards' | 'inStandards';
	}) => {
		const index = jobRiskFactors.findIndex(
			(item) => item.jobProfileRiskFactor.id === focusedId,
		);

		const element = jobRiskFactors[index]?.jobProfileRiskFactor;

		if (element) {
			jobRiskFactors[index].jobProfileRiskFactor.examResult = selected.id;
			setJobRiskFactors([...jobRiskFactors]);
		}
	};

	const handleOpenChat = () => {
		if (window.fcWidget) {
			window.fcWidget.open();
		}
	};

	return (
		<Container>
			<Select
				label="Resultado del estudio"
				initialSelected={examResultOptions.find(
					(option) =>
						option.id ===
						jobRiskFactors.find(
							(item) => item.jobProfileRiskFactor.id === focusedId,
						)?.jobProfileRiskFactor.examResult,
				)}
				options={examResultOptions.map((option) => ({
					id: option.id,
					value: option.value,
				}))}
				onChange={handleSelectResult}
			/>

			{!isCompanyPermited && (
				<Banner>
					<Title>
						<img src={calendar} alt="" width="55px" />
						<div>
							<Paragraph
								fontSize="16px"
								fontWeight="600"
								color={tokens.color_primary}
							>
								Campañas NOM - 035
							</Paragraph>
							<Paragraph fontWeight="600">
								¿Quieres evaluar factores de riesgo psicosocial en tu empresa?
							</Paragraph>
						</div>
					</Title>

					<hr className="horizontal-ruller" />

					<InfoContainer>
						<Paragraph
							fontWeight="600"
							fontSize="16px"
							margin="0 0 30px 0"
							color={tokens.color_primary}
						>
							Mejora tu plan para acceder a todos los beneficios
						</Paragraph>
						<Benefits>
							{benefitItems.map((benefit) => (
								<Fragment key={benefit.text}>
									<BenefitItem>
										<img src={benefit.image} alt="" width="55px" />
										<Paragraph fontWeight="500" fontSize="14px">
											{benefit.text}
										</Paragraph>
									</BenefitItem>
								</Fragment>
							))}
						</Benefits>
					</InfoContainer>
					<MoreInfo>
						<Button width="240px" onClick={handleOpenChat}>
							Más información
						</Button>
					</MoreInfo>
				</Banner>
			)}
		</Container>
	);
};
